import React, { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Radio } from '@blueprint/ui';
import { MultiColumnDropdownWithLabel } from '@blueprint/multicolumn-dropdown';

import { PropertyTypeRadioButtonWrapper } from '../../../search/common/Dropdown.styles';
import { updateFilter, propertyTypeSelector } from '../../../reducers/filters';
import { getTranslator } from '../../i18n/getTranslator';
import { FilterOptions } from '../../../reducers/filters.types';

import searchTranslations from 'public/locales/en/search.json';

const t = getTranslator(searchTranslations);

type RadioOptions = {
    options: FilterOptions;
    onPropertyTypeChange: (evt: ChangeEvent<HTMLInputElement>) => void;
    propertyType: string | string[];
};

const PropertyTypeRadioButtons: FC<RadioOptions> = ({
    options,
    onPropertyTypeChange,
    propertyType
}) => {
    return (
        <>
            {options?.map((option) => {
                const { label, value } = option;

                const idKey = `desktop_subheader_property_type_option${
                    value ? `_${value}` : '_all'
                }`;

                const hasSelectedThisPropertyType = propertyType === value;

                return (
                    <Radio
                        key={`${value}-${label}`}
                        id={idKey}
                        data-testid={value}
                        name="option"
                        label={label}
                        value={value}
                        checked={hasSelectedThisPropertyType}
                        onChange={onPropertyTypeChange}
                    />
                );
            })}
        </>
    );
};

export const SelectPropertyType: FC = () => {
    const reduxDispatch = useDispatch();
    const {
        selectedValue: propertyTypeSelectedValue,
        options: propertyTypeOptions
    } = useSelector(propertyTypeSelector);

    const onPropertyTypeChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('propertyType', evt.currentTarget.value));
    };

    const propertyTypeLabel = t('filters.field.property_type_label.label');
    const propertyTypeTitle = t(
        `filters.field.property_type.options.${propertyTypeSelectedValue}`
    );

    return (
        <MultiColumnDropdownWithLabel
            title={propertyTypeTitle}
            label={propertyTypeLabel}
            testId="PropertyType_testId"
            isLeft
            minWidthOverride="100%"
        >
            <PropertyTypeRadioButtonWrapper>
                <PropertyTypeRadioButtons
                    onPropertyTypeChange={onPropertyTypeChange}
                    propertyType={propertyTypeSelectedValue}
                    options={propertyTypeOptions}
                />
            </PropertyTypeRadioButtonWrapper>
        </MultiColumnDropdownWithLabel>
    );
};
